const productCache = {};

const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);

  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);

  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy";

  return newImage;
};

const getProductData = (handle) => {
  if (productCache[handle]) {
    return Promise.resolve(productCache[handle]);
  }

  return jQuery
    .getJSON(window.Shopify.routes.root + `products/${handle}.js`)
    .then((product) => {
      productCache[handle] = product;
      return product;
    });
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (!event.currentTarget.checked || !primaryImage || !handleProduct) return;

        const swatchLink = wrapper.querySelector(".js-color-swatches-link");

        if (swatchLink && event.currentTarget.dataset.variantLink) {
          swatchLink.setAttribute("href", event.currentTarget.dataset.variantLink);
        }

        const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
        const buttonText = wrapper.querySelector('.card__add-to-cart button[name="add"] > span');
        const soldOutMessage = wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message');
        const variantInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');

        if (addButton) {
          addButton.setAttribute("aria-disabled", "false");
        }

        if (buttonText) {
          buttonText.classList.remove("hidden");
        }

        if (soldOutMessage) {
          soldOutMessage.classList.add("hidden");
        }

        if (variantInput && event.currentTarget.dataset.variantId) {
          variantInput.value = event.currentTarget.dataset.variantId;
          window.productCardCartManager?.setVariant(
            wrapper,
            event.currentTarget.dataset.variantId
          );
        }

        const currentColor = event.currentTarget.value;

        getProductData(handleProduct).then((product) => {
          const selectedVariant = product.variants.find(
            (item) => item.id.toString() === event.currentTarget.dataset.variantId
          );

          if (selectedVariant) {
            window.productCardCartManager?.setVariant(
              wrapper,
              selectedVariant.id,
              selectedVariant
            );
          }

          const variant = product.variants.find((item) =>
            item.featured_media != null && item.options.includes(currentColor)
          );

          if (!variant) return;

          const newPrimaryImage = createImageElement(
            variant["featured_media"],
            primaryImage.className,
            primaryImage.sizes,
            product.title
          );

          if (newPrimaryImage.src === primaryImage.src) return;

          let flag = false;

          if (secondaryImage) {
            const secondaryImagePathname = new URL(secondaryImage.src).pathname;
            const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

            if (secondaryImagePathname === newPrimaryImagePathname) {
              primaryImage.remove();
              secondaryImage.classList.remove("media--second");
              secondaryImage.classList.add("media--first");
              flag = true;
            }
          }

          if (!flag) {
            primaryImage.animate(
              { opacity: [1, 0] },
              { duration: 200, easing: "ease-in", fill: "forwards" }
            );

            setTimeout(() => {
              primaryImage.replaceWith(newPrimaryImage);

              newPrimaryImage.animate(
                { opacity: [0, 1] },
                { duration: 200, easing: "ease-in" }
              );

              if (secondaryImage) {
                secondaryImage.remove();
              }
            }, 200);
          }
        });
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();

(() => {
  if (window.productCardCartManager) return;

  class ProductCardCartManager {
    constructor() {
      this.quantities = new Map();
      this.linesByVariant = new Map();
      this.pendingVariants = new Set();
      this.hasLoadedCart = false;
      this.refreshTimer = undefined;
      this.requestNumber = 0;

      this.handleQuantityChange = this.handleQuantityChange.bind(this);
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handleCartLinkClick = this.handleCartLinkClick.bind(this);
      this.handleRebuyCartUpdate = this.handleRebuyCartUpdate.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);

      this.seedFromMarkup(document);
      this.syncAll(document);

      document.addEventListener('change', this.handleQuantityChange);
      document.addEventListener('click', this.handleCartLinkClick);
      document.addEventListener('rebuy:cart.change', this.handleRebuyCartUpdate);
      window.addEventListener('pageshow', this.handlePageShow);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          this.handleCartUpdate
        );
      }

      this.observeNewCards();
      this.scheduleRefresh();
    }

    getControls(root = document) {
      const controls = [];

      if (root instanceof Element && root.matches('[data-card-purchase-controls]')) {
        controls.push(root);
      }

      if (root.querySelectorAll) {
        controls.push(...root.querySelectorAll('[data-card-purchase-controls]'));
      }

      return controls;
    }

    seedFromMarkup(root) {
      if (this.hasLoadedCart) return;

      this.getControls(root).forEach((control) => {
        const variantId = this.getVariantId(control);
        const quantity = Number.parseInt(control.dataset.cardInitialQuantity || '0', 10);

        if (variantId && !this.quantities.has(variantId)) {
          this.quantities.set(variantId, Number.isNaN(quantity) ? 0 : quantity);
        }
      });
    }

    observeNewCards() {
      if (!document.documentElement || typeof MutationObserver === 'undefined') return;

      this.cardObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            if (
              !node.matches('[data-card-purchase-controls]') &&
              !node.querySelector('[data-card-purchase-controls]')
            ) return;

            this.seedFromMarkup(node);
            this.syncAll(node);
          });
        });
      });

      this.cardObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    getVariantId(control) {
      const variantInput = control.querySelector('input[name="id"]');
      return String(variantInput?.value || control.dataset.cardVariantId || '');
    }

    getQuantity(variantId) {
      return this.quantities.get(String(variantId)) || 0;
    }

    getMax(control) {
      const value = Number.parseInt(control.dataset.cardMax || '', 10);
      return Number.isNaN(value) ? null : value;
    }

    setVariant(wrapper, variantId, variantData = null) {
      const control = wrapper?.querySelector('[data-card-purchase-controls]');
      if (!control || !variantId) return;

      control.dataset.cardVariantId = String(variantId);

      const inventoryIsLimited =
        variantData?.inventory_management && variantData?.inventory_policy === 'deny';

      if (inventoryIsLimited) {
        control.dataset.cardMax = String(variantData.inventory_quantity);
      } else if (variantData) {
        delete control.dataset.cardMax;
      }

      this.syncControl(control);
    }

    syncAll(root = document) {
      this.getControls(root).forEach((control) => this.syncControl(control));
    }

    syncVariant(variantId) {
      document.querySelectorAll('[data-card-purchase-controls]').forEach((control) => {
        if (this.getVariantId(control) === String(variantId)) {
          this.syncControl(control);
        }
      });
    }

    syncControl(control) {
      const variantId = this.getVariantId(control);
      if (!variantId) return;

      control.dataset.cardVariantId = variantId;

      const quantity = this.getQuantity(variantId);
      const max = this.getMax(control);
      const isPending = this.pendingVariants.has(variantId);
      const addForm = control.querySelector('[data-card-add-form]');
      const quantityControl = control.querySelector('[data-card-quantity-control]');
      const quantityInput = control.querySelector('[data-card-quantity-input]');
      const quantityValue = control.querySelector('[data-card-quantity-value]');
      const cartLink = control.querySelector('[data-card-cart-link]');
      const minusButton = control.querySelector('[name="minus"]');
      const plusButton = control.querySelector('[name="plus"]');
      const activeElement = document.activeElement;
      const focusWasInAddForm = addForm?.contains(activeElement);
      const focusWasInQuantity = quantityControl?.contains(activeElement);

      control.toggleAttribute('aria-busy', isPending);

      if (quantityInput) {
        quantityInput.value = String(quantity);
        if (max === null) {
          quantityInput.removeAttribute('max');
        } else {
          quantityInput.max = String(max);
        }
      }

      if (quantityValue) quantityValue.textContent = String(quantity);
      if (cartLink) cartLink.setAttribute('aria-label', `View cart. Quantity: ${quantity}.`);
      if (minusButton) minusButton.disabled = isPending || quantity < 1;
      if (plusButton) plusButton.disabled = isPending || (max !== null && quantity >= max);

      const isInCart = quantity > 0;
      addForm?.toggleAttribute('hidden', isInCart);
      quantityControl?.toggleAttribute('hidden', !isInCart);

      if (focusWasInAddForm && isInCart) {
        window.requestAnimationFrame(() => plusButton?.focus());
      } else if (focusWasInQuantity && !isInCart) {
        window.requestAnimationFrame(() => addForm?.querySelector('button[name="add"]')?.focus());
      }
    }

    handleQuantityChange(event) {
      const input = event.target.closest?.('[data-card-quantity-input]');
      if (!input) return;

      const control = input.closest('[data-card-purchase-controls]');
      const variantId = this.getVariantId(control);
      const currentQuantity = this.getQuantity(variantId);
      const max = this.getMax(control);
      let requestedQuantity = Number.parseInt(input.value, 10);

      if (Number.isNaN(requestedQuantity)) requestedQuantity = currentQuantity;
      requestedQuantity = Math.max(0, requestedQuantity);
      if (max !== null) requestedQuantity = Math.min(requestedQuantity, max);

      if (requestedQuantity === currentQuantity || this.pendingVariants.has(variantId)) {
        input.value = String(currentQuantity);
        return;
      }

      this.updateQuantity(variantId, requestedQuantity);
    }

    handleCartUpdate(event) {
      this.scheduleRefresh(80);

      if (event?.source === 'product-form') {
        this.openCartDrawer({ refresh: false });
      }
    }

    handleCartLinkClick(event) {
      const cartLink = event.target.closest?.('[data-card-cart-link]');
      if (!cartLink) return;

      event.preventDefault();
      this.openCartDrawer({ activeElement: cartLink });
    }

    handleRebuyCartUpdate() {
      this.scheduleRefresh(120);
    }

    handlePageShow(event) {
      if (event.persisted) this.scheduleRefresh();
    }

    openCartDrawer({ refresh = true, activeElement = document.activeElement } = {}) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      drawer.setActiveElement?.(activeElement);

      if (refresh && typeof drawer.scheduleRefresh === 'function') {
        drawer.scheduleRefresh({ open: true, delay: 40 });
      } else {
        drawer.open?.(activeElement);
      }
    }

    scheduleRefresh(delay = 0) {
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.refresh(), delay);
    }

    async refresh() {
      const requestNumber = ++this.requestNumber;
      const root = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });

        if (!response.ok) throw new Error(`Cart request failed with ${response.status}`);

        const cart = await response.json();
        if (requestNumber !== this.requestNumber) return;

        this.applyCart(cart);
      } catch (error) {
        console.error('Unable to synchronize product-card quantities.', error);
        this.pendingVariants.clear();
        this.syncAll(document);
      }
    }

    applyCart(cart) {
      const quantities = new Map();
      const linesByVariant = new Map();

      (cart.items || []).forEach((item) => {
        const variantId = String(item.variant_id || item.id);
        quantities.set(variantId, (quantities.get(variantId) || 0) + item.quantity);

        if (!linesByVariant.has(variantId)) linesByVariant.set(variantId, []);
        linesByVariant.get(variantId).push({
          key: item.key,
          quantity: item.quantity
        });
      });

      this.quantities = quantities;
      this.linesByVariant = linesByVariant;
      this.hasLoadedCart = true;
      this.pendingVariants.clear();
      this.syncAll(document);
    }

    buildLineUpdates(variantId, requestedQuantity) {
      const lines = this.linesByVariant.get(String(variantId)) || [];
      if (!lines.length) return null;

      const updates = {};
      const currentTotal = lines.reduce((total, line) => total + line.quantity, 0);
      let difference = requestedQuantity - currentTotal;

      lines.forEach((line) => {
        updates[line.key] = line.quantity;
      });

      if (difference >= 0) {
        updates[lines[0].key] += difference;
        return updates;
      }

      difference = Math.abs(difference);
      lines.forEach((line) => {
        if (difference === 0) return;
        const reduction = Math.min(updates[line.key], difference);
        updates[line.key] -= reduction;
        difference -= reduction;
      });

      return updates;
    }

    async updateQuantity(variantId, requestedQuantity) {
      const id = String(variantId);
      const previousQuantity = this.getQuantity(id);
      const lines = this.linesByVariant.get(id) || [];
      const isAdding = requestedQuantity > previousQuantity;

      this.pendingVariants.add(id);
      this.quantities.set(id, requestedQuantity);
      this.syncVariant(id);

      try {
        if (
          lines.length === 1 &&
          window.Rebuy?.Cart?.changeItem
        ) {
          const result = window.Rebuy.Cart.changeItem({
            id: lines[0].key,
            quantity: requestedQuantity
          });

          if (result && typeof result.then === 'function') await result;
          if (isAdding) document.querySelector('cart-drawer')?.rememberLastAddedVariant?.(id);
          this.scheduleRefresh(result && typeof result.then === 'function' ? 80 : 500);
          window.setTimeout(() => this.scheduleRefresh(), 2000);
          if (isAdding) this.openCartDrawer();
          return;
        }

        const updates = this.buildLineUpdates(id, requestedQuantity);
        if (!updates) throw new Error('The cart line could not be found.');

        const root = window.Shopify?.routes?.root || '/';
        const updateUrl = window.routes?.cart_update_url || `${root}cart/update.js`;
        const response = await fetch(updateUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        const cart = await response.json();
        if (!response.ok || cart.status) {
          throw new Error(cart.description || cart.message || 'Cart update failed.');
        }

        this.applyCart(cart);
        if (isAdding) document.querySelector('cart-drawer')?.rememberLastAddedVariant?.(id);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-card-quantity',
            productVariantId: id
          });
        }

        if (isAdding) this.openCartDrawer();
      } catch (error) {
        console.error('Unable to update the product-card quantity.', error);
        this.quantities.set(id, previousQuantity);
        this.pendingVariants.delete(id);
        this.syncVariant(id);
        this.scheduleRefresh();
      }
    }
  }

  window.productCardCartManager = new ProductCardCartManager();
})();
